export default __webpack_public_path__ + "static/media/delivery_wpp.2851e87a.png";